import type { DifficultyId } from '../types/primitives'
import { DIFFICULTY_IDS } from '../types/primitives'

/** Stored clears — do not store derived star count. */
export interface StageDifficultyClears {
  easy: boolean
  normal: boolean
  hard: boolean
  insane: boolean
}

export function emptyClears(): StageDifficultyClears {
  return { easy: false, normal: false, hard: false, insane: false }
}

/**
 * Completing a higher difficulty implies lower clears (cascade).
 */
export function applyDifficultyClear(
  previous: StageDifficultyClears,
  cleared: DifficultyId
): StageDifficultyClears {
  const next = { ...previous }
  const order: DifficultyId[] = ['easy', 'normal', 'hard', 'insane']
  const idx = order.indexOf(cleared)
  for (let i = 0; i <= idx; i += 1) {
    next[order[i]!] = true
  }
  return next
}

/** Derive ★ count from clears (max 4). */
export function starCountFromClears(clears: StageDifficultyClears): number {
  let n = 0
  for (const id of DIFFICULTY_IDS) {
    if (clears[id]) n += 1
  }
  return n
}

export interface StageCompletionResult {
  clears: StageDifficultyClears
  starCount: number
}

export function resolveStageCompletion(
  previous: StageDifficultyClears,
  cleared: DifficultyId
): StageCompletionResult {
  const clears = applyDifficultyClear(previous, cleared)
  return { clears, starCount: starCountFromClears(clears) }
}
